import { useEffect, useMemo, useRef, useState } from "react";
import { CommonDataTable } from "../../common-components/common-material-react-table/CommonMaterialTable";
import { SegRecords } from "../../constants/tableConstants/tableHeaders";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import dayjs from "dayjs";
import {
  FetchSegRecord,
  setSelectedRowIndex,
  UpdatePagination,
  emptySEGMainPage,
  titleListSortByDesc,
  setscrolling,
  resetSEGPage,
} from "../../redux/reducers/Segreducer";
import { useNavigate } from "react-router-dom";
import {
  FetchSeason,
  UpdateSelectedSeason,
  UpdateSelectedSeasonList,
} from "../../redux/reducers/SeasonReducer";
import Select, { components } from "react-select";
import {
  fetchDivision,
  UpdateSelectedDivision,
  UpdateSelectedDivisionList,
} from "../../redux/reducers/DivisionReducer";
import {
  fetchImprint,
  UpdateSelectedImprint,
  UpdateSelectedImprintList,
} from "../../redux/reducers/ImprintReducer";
import {
  fetchPaperCutOffDates,
  UpdateSelectedPaperCutOffDate,
  UpdateSelectedPaperCutOffDateList,
} from "../../redux/reducers/PaperCutOffDateReducer";
import {
  fetchLdcDates,
  UpdateSelectedLdc,
  UpdateSelectedLdcList,
} from "../../redux/reducers/LdcReducer";
import { Controller, useForm } from "react-hook-form";

import { setSelectedSeg, UpdatetableCond, handleLocalClear, setNoSegId, setLocal, UpdateSelectedIsbnValue, setRenderSeason, setResetSeason } from "../../redux/reducers/OTISReducer";

import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  fetchAccounts,
  fetchIsbnList,
  ISBNData,
  setIsbnString,
  updateAccountPage,
  updateSearchStr,
  UpdateSelectedAccountList,
  UpdateSelectedISBNS,
  UpdateSelectedISBNSList,
  UpdateSelectedAccounts,
  UpdateSelectedTitles,
  UpdateSelectedTitlesList,
  updateIsbnSkip,
  resetSkip,
  resetIsbns,
  setSkip,
  resetSkipForOtis,
  setClickedIsbn,
  setIsbnStringForOtis,
  setIsbnState,
} from "../../redux/reducers/ISBNSReducer";
import { formatCurrency } from "../../common-components/commonFunctions";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { Skeleton, useMediaQuery } from "@mui/material";
import { API } from "../../constants/API";
import axios from "axios";
import { formatNumber } from "../../utils/formatNumber";

// Custom Loader for Select Components
const CustomSelectLoader = () => (
  <div className="flex items-center justify-center pr-2">
    <svg
      className="animate-spin h-5 w-5 text-gray-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </div>
);

const SegSummarySkeleton = () => (
  <div className="w-full">
    <div className="rounded-md border border-gray-200 bg-white p-3">
      <div className="mb-3">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-3 xl:grid-cols-6">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={`seg-filter-row-one-${index}`}>
              <Skeleton variant="text" width={70} height={14} sx={{ mb: 0.5 }} />
              <Skeleton variant="rounded" height={34} />
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2 md:grid-cols-3 xl:grid-cols-6">
        {Array.from({ length: 2 }).map((_, index) => (
          <div key={`seg-filter-row-two-${index}`}>
            <Skeleton variant="text" width={55} height={14} sx={{ mb: 0.5 }} />
            <Skeleton variant="rounded" height={34} />
          </div>
        ))}
        <div className="md:col-span-1 xl:col-span-2 flex items-end gap-2">
          <Skeleton variant="rounded" width={84} height={34} />
          <Skeleton variant="rounded" width={122} height={34} />
          <Skeleton variant="rounded" width={92} height={34} />
        </div>
      </div>
    </div>

    <div className="mt-3 rounded-md border border-gray-200 overflow-hidden bg-white">
      <div className="grid grid-cols-12 gap-0 border-b border-gray-200 bg-gray-100">
        {Array.from({ length: 12 }).map((_, index) => (
          <div key={`seg-header-skeleton-${index}`} className="border-r border-gray-200 px-2 py-2 last:border-r-0">
            <Skeleton variant="text" width="80%" height={16} />
          </div>
        ))}
      </div>
      {Array.from({ length: 12 }).map((_, rowIndex) => (
        <div
          key={`seg-table-row-skeleton-${rowIndex}`}
          className="grid grid-cols-12 gap-0 border-b border-gray-100 last:border-b-0"
        >
          {Array.from({ length: 12 }).map((_, cellIndex) => (
            <div
              key={`seg-table-cell-skeleton-${rowIndex}-${cellIndex}`}
              className="border-r border-gray-100 px-2 py-2 last:border-r-0"
            >
              <Skeleton
                variant="text"
                width={cellIndex === 2 ? "90%" : "70%"}
                height={14}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

interface OptionType {
  value: string;
  label: string;
}

interface FormValues {
  season: OptionType[];
  paperCutOffDate: OptionType[];
  ldc: OptionType[];
  division: OptionType[];
  imprint: OptionType[];
  title: OptionType[];
  isbn: OptionType[];
  accountName: OptionType[];
}

interface MeetingReportRow {
  rowType: "distribution" | "organization" | "account";
  distributionChannel: string;
  organization: string;
  accountName: string;
  accountNumber: string;
  initialOrder: string;
  salesNotes: string;
  laydownGoal: string;
  laydownEstimate: string;
  sixMonthEstimate: string;
  compInit: string;
  compGross: string;
  compNet: string;
  compReturns: string;
  comp4wkPos: string;
  comp8wkPos: string;
  compLtdPos: string;
}

interface MeetingReportSection {
  isbn: string;
  segTitle: any;
  segTitleNotes?: string;
  comparableTitle?: any | null;
  comparableLtd?: string | number;
  comparableBksnPos?: string | number;
  comparableEbookSales?: string | number;
  rows: MeetingReportRow[];
}
const SegMainTable = () => {
  const { control, watch, setValue } = useForm<FormValues>();
  const SegData = useSelector((state: RootState) => state.SegReducer.data);
  const page = useSelector((state: RootState) => state.SegReducer.page);
  const limit = useSelector((state: RootState) => state.SegReducer.limit);
  const isLoading = useSelector(
    (state: RootState) => state.SegReducer.isLoading
  );
  const isbnIsLoading = useSelector(
    (state: RootState) => state.isbnReducer.isLoading
  );
  const seasonIsLoading = useSelector(
    (state: RootState) => state.SeasonReducer.isLoading
  );
  const divisionIsLoading = useSelector(
    (state: RootState) => state.DivisionReducer.isLoading
  );
  const imprintIsLoading = useSelector(
    (state: RootState) => state.ImprintReducer.isLoading
  );
  const paperCutOffDateIsLoading = useSelector(
    (state: RootState) => state.PaperCutOffDateReducer.isLoading
  );
  const ldcIsLoading = useSelector(
    (state: RootState) => state.LdcReducer.isLoading
  );
  const accountIsLoading = useSelector(
    (state: RootState) => state.isbnReducer.accountIsLoading
  );

  const hasMore = useSelector((state: RootState) => state.SegReducer.hasMore);
  const isbnLimit = useSelector(
    (state: RootState) => state.isbnReducer.isbnLimit
  );
  // const [isbnSkip, setIsbnSkip] = useState(0);
  const isbnSkip = useSelector(
    (state: RootState) => state.isbnReducer.isbnSkip
  );
  console.log("isbnSkip", isbnSkip);
  const isbns = useSelector(ISBNData);
  const oldISBNS = isbns?.length ? isbns.map((isbn) => isbn._id) : [];
  // const isbnsString = useSelector(
  //   (state: RootState) => state.isbnReducer.isbnsString
  // );
  const [isbn_number_options, set_ISBN_NUMBER_OPTION] = useState<OptionType[]>(
    []
  );
  const [isbn_title_options, set_ISBN_TITLE_OPTION] = useState<OptionType[]>(
    []
  );
  const [LoadingTest, setLoadingTest] = useState(false);
  const [meetingReportLoading, setMeetingReportLoading] = useState(false);
  const [meetingReportProgress, setMeetingReportProgress] = useState("");
  const [meetingReportSections, setMeetingReportSections] = useState<MeetingReportSection[]>([]);
  const lastFilterRequestKeyRef = useRef("");
  const hasSkippedInitialCommonIsbnFetchRef = useRef(false);
  const reportContainerRef = useRef<HTMLDivElement | null>(null);

  const SegReducer = useSelector((state: RootState) => state.SegReducer);
  // setting the values of all matched isbns
  useEffect(() => {
    if (isbns?.length) {
      set_ISBN_NUMBER_OPTION(
        isbns.map((isbn: any) => ({
          value: isbn.ISBN ?? "",
          label: isbn.ISBN ?? "",
        }))
      );
      set_ISBN_TITLE_OPTION(
        isbns.map((isbn: any) => ({
          value: isbn.ISBN ?? "",
          label: isbn.FULL_TITLE ?? "",
        }))
      );
    }
  }, [isbns]);

  const selectedRowIndex = useSelector(
    (state: RootState) => state.SegReducer.selectedRowIndex
  );
  const selectedSeason = useSelector(
    (state: RootState) => state.SeasonReducer.selectedSeason
  );
  const selectedSeasonlist = useSelector(
    (state: RootState) => state.SeasonReducer.selectedSeasonList
  );

  const selectedDivision = useSelector(
    (state: RootState) => state.DivisionReducer.selectedDivision
  );
  const selectedDivisionlist = useSelector(
    (state: RootState) => state.DivisionReducer.selectedDivisionList
  );
  const isbnsString = useSelector(
    (state: RootState) => state.isbnReducer.isbnsString
  );
  const selectedImprint = useSelector(
    (state: RootState) => state.ImprintReducer.selectedImprint
  );
  const selectedImprintlist = useSelector(
    (state: RootState) => state.ImprintReducer.selectedImprintList
  );
  const selectedAccounts = useSelector(
    (state: RootState) => state.isbnReducer.selectedAccounts
  );
  const selectedAccountList = useSelector(
    (state: RootState) => state.isbnReducer.selectedAccountList
  );
  const selectedIsbnsList = useSelector(
    (state: RootState) => state.isbnReducer.selectedISBNSList
  );
  const selectedTitlesList = useSelector(
    (state: RootState) => state.isbnReducer.selectedTitlesList
  );

  const selectedIsbns = useSelector(
    (state: RootState) => state.isbnReducer.selectedISBNS
  );

  const navigate = useNavigate();
  const SeasonData = useSelector(
    (state: RootState) => state.SeasonReducer.data
  );
  const divisionData = useSelector(
    (state: RootState) => state.DivisionReducer.data
  );
  const imprintData = useSelector(
    (state: RootState) => state.ImprintReducer.data
  );
  const paperCutOffDateData = useSelector(
    (state: RootState) => state.PaperCutOffDateReducer.data
  );
  const selectedPaperCutOffDate = useSelector(
    (state: RootState) => state.PaperCutOffDateReducer.selectedPaperCutOffDate
  );
  const selectedPaperCutOffDateList = useSelector(
    (state: RootState) => state.PaperCutOffDateReducer.selectedPaperCutOffDateList
  );
  const ldcData = useSelector(
    (state: RootState) => state.LdcReducer.data
  );
  const selectedLdc = useSelector(
    (state: RootState) => state.LdcReducer.selectedLdc
  );
  const selectedLdcList = useSelector(
    (state: RootState) => state.LdcReducer.selectedLdcList
  );
  const bgElement = useSelector(
    (state: RootState) => state.dropdownReducer.bgElement
  );

  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const accountData = useSelector(
    (state: RootState) => state.isbnReducer.accounts
  );

  const oldAccounts = accountData.accounts?.length
    ? accountData.accounts.map((account) => account._id)
    : [];

  const dispatch = useDispatch<AppDispatch>();

  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [CrossDisabled, setCrossDisabled] = useState(true)
  const [isbn, setIsbn] = useState<string[]>([])
  const [imprint, setImprint] = useState<string[]>([])
  const [division, setDivision] = useState<string[]>([])
  const [season, setSeason] = useState<string[]>([])
  const [paperCutOffDate, setPaperCutOffDate] = useState<string[]>([])
  const [ldc, setLdc] = useState<string[]>([])
  const isFirefox = typeof navigator !== "undefined" && navigator.userAgent.includes("Firefox");


  useEffect(() => {
    dispatch(UpdateSelectedIsbnValue(""))
  }, [dispatch])


  const downloadSegData = async (data: any) => {
    setLoadingTest(true);
    try {
      const response = await axios.post(API.Dowanload_fetchSEGRecords, data, {
        responseType: "blob", // Ensures correct handling of binary data
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      const formatDate = dayjs().format("MMMM-DD-YYYY-HHmmss");
      a.download = `SEG Summary ${formatDate}.xlsx`; // Dynamically generate filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      console.error("Error downloading file:", err);
      alert("Failed to download the file. Please try again.");
    } finally {
      setLoadingTest(false);
    }
  };

  const decimalToString = (value: any): string => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object" && value.$numberDecimal !== undefined) {
      return value.$numberDecimal === "" ? "-" : String(value.$numberDecimal);
    }
    return String(value);
  };

  const formatDateString = (value: any, format = "MM/DD/YYYY"): string => {
    if (!value) return "-";
    return moment(value).isValid() ? moment(value).format(format) : "-";
  };

  const normalizeNumeric = (value: any): number => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "object" && value.$numberDecimal !== undefined) {
      const parsed = Number(value.$numberDecimal);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    if (typeof value === "string") {
      const cleaned = value.replace(/[^0-9.-]/g, "");
      const parsed = Number(cleaned);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const fetchComparableSummary = async (eanSelectedValueRaw: any) => {
    const comparableId =
      eanSelectedValueRaw?.value ??
      (typeof eanSelectedValueRaw === "string" ? eanSelectedValueRaw : "");
    if (!comparableId) return null;
    try {
      const [summaryResponse, digPosResponse] = await Promise.all([
        axios.post(API.fetchSelectedSegSummary, { value: comparableId }),
        axios.post(API.FETCHDIGPOST, { value: comparableId }),
      ]);
      return {
        selectedSeg: summaryResponse?.data?.selectedSeg ?? null,
        ltdGrossUnits: summaryResponse?.data?.ltdGrossUnits ?? "-",
        bksnPos: summaryResponse?.data?.bksnPos ?? "-",
        ebookSales: digPosResponse?.data?.total_ordered_units ?? "-",
      };
    } catch (error) {
      try {
        const response = await axios.post(API.fetchSelectedSegSummary, {
          value: comparableId,
        });
        return {
          selectedSeg: response?.data?.selectedSeg ?? null,
          ltdGrossUnits: response?.data?.ltdGrossUnits ?? "-",
          bksnPos: response?.data?.bksnPos ?? "-",
          ebookSales: "-",
        };
      } catch {
        return null;
      }
    }
  };

  const buildMeetingRows = (segOtisRecords: any[] = []): MeetingReportRow[] => {
    const rows: MeetingReportRow[] = [];
    segOtisRecords.forEach((record: any) => {
      const organizations = Array.isArray(record?.organizations) ? record.organizations : [];
      const validAccounts = organizations.flatMap((org: any) => (
        Array.isArray(org?.accounts) ? org.accounts : []
      ));

      const channelName =
        record?.DISTRIBUTION_CHANNEL_NAME != null
          ? String(record.DISTRIBUTION_CHANNEL_NAME).trim()
          : "";
      const channelCodeRaw =
        record?.DISTRIBUTION_CHANNEL != null ? String(record.DISTRIBUTION_CHANNEL).trim() : "";
      const hasChannel = channelName.length > 0 || channelCodeRaw.length > 0;

      const hasDistLevelData =
        normalizeNumeric(record?.main_pubgoal) !== 0 ||
        normalizeNumeric(record?.main_current_estimate) !== 0 ||
        normalizeNumeric(record?.main_supplemental_estimate) !== 0;

      const hasOrgLevelData = organizations.some(
        (org: any) =>
          normalizeNumeric(org?.org_pub_goal) !== 0 ||
          normalizeNumeric(org?.org_current_estimate) !== 0 ||
          normalizeNumeric(org?.org_supplemental_estimate) !== 0
      );

      // Skip empty distribution stubs (e.g. unsaved "add row" placeholders) so PDF/exports do not show "Not Defined" rows.
      if (!hasChannel && validAccounts.length === 0 && !hasDistLevelData && !hasOrgLevelData) {
        return;
      }

      const distributionLabel = channelName || "Not Defined";
      const distributionCode = (record?.DISTRIBUTION_CHANNEL ?? distributionLabel).toString().trim().toUpperCase();
      const canExpandAccounts = distributionCode === "MASSMER" || distributionCode === "RETINDEP";

      const aggregateAccounts = (accounts: any[]) => ({
        units: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.units), 0),
        pubGoal: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.pub_goal), 0),
        currEst: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.currEst), 0),
        suppEst: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.suppEst), 0),
        compInit: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.compInit), 0),
        compGross: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.compGross), 0),
        compNet: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.compNet), 0),
        compReturns: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.retPercentage), 0),
        comp4wkPos: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.cpos4wkPOS), 0),
        comp8wkPos: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.cpos8wkPOS), 0),
        compLtdPos: accounts.reduce((sum, acc) => sum + normalizeNumeric(acc?.Cpos_LTD), 0),
      });

      const hasMeaningfulValue = (value: any) => {
        return normalizeNumeric(value) !== 0;
      };

      const pickValueWithPrecedence = (
        primaryValue: any,
        secondaryValues: any[],
        tertiaryValues: any[]
      ) => {
        if (hasMeaningfulValue(primaryValue)) {
          return normalizeNumeric(primaryValue);
        }
        const hasSecondary = secondaryValues.some((val) => hasMeaningfulValue(val));
        if (hasSecondary) {
          return secondaryValues.reduce((sum, val) => sum + normalizeNumeric(val), 0);
        }
        return tertiaryValues.reduce((sum, val) => sum + normalizeNumeric(val), 0);
      };

      const combineSalesNotes = (accounts: any[]) => {
        const notes = accounts
          .map((acc) => (typeof acc?.sales_notes === "string" ? acc.sales_notes.trim() : ""))
          .filter((note) => note.length > 0);
        if (!notes.length) return "-";
        return Array.from(new Set(notes)).join(" | ");
      };
      const normalizeSalesNote = (value: any) => {
        if (typeof value !== "string") return "";
        return value.trim();
      };

      const distributionTotals = aggregateAccounts(validAccounts);
      const distributionGoal = pickValueWithPrecedence(
        record?.main_pubgoal,
        organizations.map((org: any) => org?.org_pub_goal),
        validAccounts.map((acc: any) => acc?.pub_goal)
      );
      const distributionCurrEst = pickValueWithPrecedence(
        record?.main_current_estimate,
        organizations.map((org: any) => org?.org_current_estimate),
        validAccounts.map((acc: any) => acc?.currEst)
      );
      const distributionSuppEst = pickValueWithPrecedence(
        record?.main_supplemental_estimate,
        organizations.map((org: any) => org?.org_supplemental_estimate),
        validAccounts.map((acc: any) => acc?.suppEst)
      );
      const distributionSalesNotes =
        normalizeSalesNote(record?.main_sales_notes) || combineSalesNotes(validAccounts);
      rows.push({
        rowType: "distribution",
        distributionChannel: `${distributionLabel}\n${record?.DISTRIBUTION_CHANNEL ? `[${record.DISTRIBUTION_CHANNEL}]` : ""}`.trim(),
        organization: `Total Organizations (${organizations.length})`,
        accountName: `Total Accounts (${validAccounts.length})`,
        accountNumber: "",
        initialOrder: decimalToString(distributionTotals.units),
        salesNotes: distributionSalesNotes,
        laydownGoal: decimalToString(distributionGoal),
        laydownEstimate: decimalToString(distributionCurrEst),
        sixMonthEstimate: decimalToString(distributionSuppEst),
        compInit: decimalToString(distributionTotals.compInit),
        compGross: decimalToString(distributionTotals.compGross),
        compNet: decimalToString(distributionTotals.compNet),
        compReturns: decimalToString(distributionTotals.compReturns),
        comp4wkPos: decimalToString(distributionTotals.comp4wkPos),
        comp8wkPos: decimalToString(distributionTotals.comp8wkPos),
        compLtdPos: decimalToString(distributionTotals.compLtdPos),
      });

      organizations.forEach((organization: any) => {
        const orgAccounts = Array.isArray(organization?.accounts)
          ? organization.accounts
          : [];
        if (!orgAccounts.length) return;
        const orgTotals = aggregateAccounts(orgAccounts);
        const orgGoal = pickValueWithPrecedence(
          organization?.org_pub_goal,
          [],
          orgAccounts.map((acc: any) => acc?.pub_goal)
        );
        const orgCurrEst = pickValueWithPrecedence(
          organization?.org_current_estimate,
          [],
          orgAccounts.map((acc: any) => acc?.currEst)
        );
        const orgSuppEst = pickValueWithPrecedence(
          organization?.org_supplemental_estimate,
          [],
          orgAccounts.map((acc: any) => acc?.suppEst)
        );
        rows.push({
          rowType: "organization",
          distributionChannel: "",
          organization: `${organization?.orgName ?? "-"}${organization?.organizationId ? ` [${organization.organizationId}]` : ""}`,
          accountName: `All Accounts (${orgAccounts.length})`,
          accountNumber: "",
          initialOrder: decimalToString(orgTotals.units),
          salesNotes: combineSalesNotes(orgAccounts),
          laydownGoal: decimalToString(orgGoal),
          laydownEstimate: decimalToString(orgCurrEst),
          sixMonthEstimate: decimalToString(orgSuppEst),
          compInit: decimalToString(orgTotals.compInit),
          compGross: decimalToString(orgTotals.compGross),
          compNet: decimalToString(orgTotals.compNet),
          compReturns: decimalToString(orgTotals.compReturns),
          comp4wkPos: decimalToString(orgTotals.comp4wkPos),
          comp8wkPos: decimalToString(orgTotals.comp8wkPos),
          compLtdPos: decimalToString(orgTotals.compLtdPos),
        });

        if (canExpandAccounts) {
          orgAccounts.filter((account: any) => account?.accountName).forEach((account: any) => {
            rows.push({
              rowType: "account",
              distributionChannel: "",
              organization: "",
              accountName: account?.accountName ?? "-",
              accountNumber: account?.accountNumber ?? "-",
              initialOrder: decimalToString(account?.units),
              salesNotes: account?.sales_notes ?? "-",
              laydownGoal: decimalToString(account?.pub_goal),
              laydownEstimate: decimalToString(account?.currEst),
              sixMonthEstimate: decimalToString(account?.suppEst),
              compInit: decimalToString(account?.compInit),
              compGross: decimalToString(account?.compGross),
              compNet: decimalToString(account?.compNet),
              compReturns: decimalToString(account?.retPercentage),
              comp4wkPos: decimalToString(account?.cpos4wkPOS),
              comp8wkPos: decimalToString(account?.cpos8wkPOS),
              compLtdPos: decimalToString(account?.Cpos_LTD),
            });
          });
        }
      });
    });
    return rows;
  };

  const chunkRows = (rows: MeetingReportRow[], chunkSize = 20): MeetingReportRow[][] => {
    if (!rows.length) return [[{
      rowType: "account",
      distributionChannel: "Not Defined",
      organization: "-",
      accountName: "-",
      accountNumber: "-",
      initialOrder: "-",
      salesNotes: "-",
      laydownGoal: "-",
      laydownEstimate: "-",
      sixMonthEstimate: "-",
      compInit: "-",
      compGross: "-",
      compNet: "-",
      compReturns: "-",
      comp4wkPos: "-",
      comp8wkPos: "-",
      compLtdPos: "-",
    }]];
    const pages: MeetingReportRow[][] = [];
    for (let idx = 0; idx < rows.length; idx += chunkSize) {
      pages.push(rows.slice(idx, idx + chunkSize));
    }
    return pages;
  };

  const parseReportNumber = (value: any): number => {
    if (value === null || value === undefined || value === "") return 0;
    const cleaned = String(value).replace(/[^0-9.-]/g, "");
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : 0;
  };

  const getSectionFooterTotals = (rows: MeetingReportRow[]) => {
    const sourceRows = rows.filter((row) => row.rowType === "distribution");
    return sourceRows.reduce(
      (acc, row) => {
        acc.initialOrder += parseReportNumber(row.initialOrder);
        acc.laydownGoal += parseReportNumber(row.laydownGoal);
        acc.laydownEstimate += parseReportNumber(row.laydownEstimate);
        acc.sixMonthEstimate += parseReportNumber(row.sixMonthEstimate);
        acc.compInit += parseReportNumber(row.compInit);
        acc.compGross += parseReportNumber(row.compGross);
        acc.compNet += parseReportNumber(row.compNet);
        acc.compLtdPos += parseReportNumber(row.compLtdPos);
        return acc;
      },
      {
        initialOrder: 0,
        laydownGoal: 0,
        laydownEstimate: 0,
        sixMonthEstimate: 0,
        compInit: 0,
        compGross: 0,
        compNet: 0,
        compLtdPos: 0,
      }
    );
  };

  const waitForRenderedSections = async (expectedCount: number, timeoutMs = 8000) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const count =
        reportContainerRef.current?.querySelectorAll(".meeting-report-section")
          ?.length ?? 0;
      if (count >= expectedCount && expectedCount > 0) {
        return count;
      }
    }
    return (
      reportContainerRef.current?.querySelectorAll(".meeting-report-section")?.length ?? 0
    );
  };

  const getCurrentSummaryFilters = () => {
    const seasonData = Array.isArray(watch("season"))
      ? watch("season").map((data) => data.value)
      : [];
    const paperCutOffDateData = Array.isArray(watch("paperCutOffDate"))
      ? watch("paperCutOffDate").map((data) => data.value)
      : [];
    const ldcDataPayload = Array.isArray(watch("ldc"))
      ? watch("ldc").map((data) => data.value)
      : [];
    const divisionData = Array.isArray(watch("division"))
      ? watch("division").map((data) => data.value)
      : [];
    const isbnsData = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];
    const imprintData = Array.isArray(watch("imprint"))
      ? watch("imprint").map((data) => data.value)
      : [];
    return {
      seasons: seasonData,
      paperCutOffDate: paperCutOffDateData,
      ldc: ldcDataPayload,
      divisions: divisionData,
      isbns: isbnsData,
      imprint: imprintData,
      prevSeason: selectedSeason,
      prevDivision: selectedDivision,
      prevImprint: selectedImprint,
      prevPaperCutOffDate: selectedPaperCutOffDate,
      prevLdc: selectedLdc,
      oldEans: [],
      selectedData: [],
      sortBy: SegReducer.titleSortBy,
    };
  };

  const downloadMeetingReportPdf = async () => {
    if (meetingReportLoading || isLoading) return;
    setMeetingReportLoading(true);
    setMeetingReportProgress("Loading filtered ISBNs...");
    try {
      const isbnResponse = await axios.post(
        API.FetchAllIsbnList,
        getCurrentSummaryFilters()
      );
      const allFilteredIsbns = Array.isArray(isbnResponse?.data?.data)
        ? isbnResponse.data.data
        : [];

      if (!allFilteredIsbns.length) {
        alert("No ISBNs found for selected filters.");
        return;
      }

      const sections: MeetingReportSection[] = [];
      const failedIsbns: string[] = [];
      for (let index = 0; index < allFilteredIsbns.length; index += 1) {
        const current = allFilteredIsbns[index];
        setMeetingReportProgress(
          `Preparing ISBN ${index + 1} of ${allFilteredIsbns.length} (${current?.ISBN ?? ""})`
        );
        try {
          const otisResponse = await axios.post(API.FETCHOTISRECORD, {
            segId: current?._id,
            EAN: current?.ISBN,
            hasMoreLimit: 1000,
          });

          const comparableData = await fetchComparableSummary(
            otisResponse?.data?.eanSelectedValue
          );
          const segTitle = otisResponse?.data?.segDetails ?? {};
          const rows = buildMeetingRows(otisResponse?.data?.SEGOTISRecords ?? []);

          sections.push({
            isbn: current?.ISBN ?? segTitle?.EAN ?? "",
            segTitle,
            segTitleNotes: otisResponse?.data?.SEGTitle ?? "-",
            comparableTitle: comparableData?.selectedSeg ?? null,
            comparableLtd: comparableData?.ltdGrossUnits ?? "-",
            comparableBksnPos: comparableData?.bksnPos ?? "-",
            comparableEbookSales: comparableData?.ebookSales ?? "-",
            rows,
          });
        } catch (isbnErr) {
          console.error("Meeting report ISBN fetch failed:", current?.ISBN, isbnErr);
          failedIsbns.push(current?.ISBN ?? `#${index + 1}`);
        }
      }

      if (!sections.length) {
        throw new Error("No report sections were generated from selected ISBNs.");
      }

      const expectedPages = sections.reduce(
        (total, section) => total + chunkRows(section.rows, 14).length,
        0
      );
      setMeetingReportSections(sections);
      setMeetingReportProgress("Rendering PDF pages...");
      const renderedCount = await waitForRenderedSections(expectedPages);
      const sectionNodes = reportContainerRef.current?.querySelectorAll(".meeting-report-section");
      if (!sectionNodes || sectionNodes.length === 0) {
        throw new Error(
          `Report sections not rendered (expected: ${expectedPages}, rendered: ${renderedCount}).`
        );
      }

      const pdf = new jsPDF("l", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 18;
      const contentWidth = pageWidth - margin * 2;
      const contentHeight = pageHeight - margin * 2;

      let renderedPdfPages = 0;
      const failedPdfPages: string[] = [];
      for (let i = 0; i < sectionNodes.length; i += 1) {
        const node = sectionNodes[i] as HTMLElement;
        setMeetingReportProgress(`Generating PDF page ${i + 1} of ${sectionNodes.length}`);
        try {
          const sourceCanvas = await html2canvas(node, {
            // Keep text sharper; memory controlled with smaller row chunks.
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            imageTimeout: 15000,
          });

          let canvas = sourceCanvas;
          const maxPixels = 3_500_000;
          const totalPixels = sourceCanvas.width * sourceCanvas.height;
          if (totalPixels > maxPixels) {
            const scaleFactor = Math.sqrt(maxPixels / totalPixels);
            const resizedCanvas = document.createElement("canvas");
            resizedCanvas.width = Math.max(1, Math.floor(sourceCanvas.width * scaleFactor));
            resizedCanvas.height = Math.max(1, Math.floor(sourceCanvas.height * scaleFactor));
            const ctx = resizedCanvas.getContext("2d");
            if (ctx) {
              ctx.drawImage(sourceCanvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
              canvas = resizedCanvas;
            }
          }

          let imageDataUrl = "";
          try {
            imageDataUrl = canvas.toDataURL("image/jpeg", 0.86);
          } catch {
            const resizedCanvas = document.createElement("canvas");
            resizedCanvas.width = Math.max(1, Math.floor(canvas.width * 0.75));
            resizedCanvas.height = Math.max(1, Math.floor(canvas.height * 0.75));
            const ctx = resizedCanvas.getContext("2d");
            if (ctx) {
              ctx.drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
            }
            canvas = resizedCanvas;
            imageDataUrl = canvas.toDataURL("image/jpeg", 0.78);
          }

          const ratio = Math.min(contentWidth / canvas.width, contentHeight / canvas.height);
          const imageWidth = canvas.width * ratio;
          const imageHeight = canvas.height * ratio;
          const offsetX = margin + (contentWidth - imageWidth) / 2;
          const offsetY = margin;
          if (renderedPdfPages > 0) {
            pdf.addPage();
          }
          pdf.addImage(imageDataUrl, "JPEG", offsetX, offsetY, imageWidth, imageHeight);
          renderedPdfPages += 1;
        } catch (pageErr: any) {
          failedPdfPages.push(`Page ${i + 1}: ${pageErr?.message || String(pageErr)}`);
        }
      }

      if (renderedPdfPages === 0) {
        throw new Error(
          `All PDF pages failed to render. ${
            failedPdfPages.slice(0, 6).join(" | ")
          }${failedPdfPages.length > 6 ? " | ..." : ""}`
        );
      }

      const formatDate = dayjs().format("MMMM-DD-YYYY-HHmmss");
      pdf.save(`SEG Meeting Report ${formatDate}.pdf`);
      if (failedIsbns.length) {
        alert(
          `Meeting Report generated with ${failedIsbns.length} skipped ISBN(s): ${failedIsbns.join(", ")}`
        );
      }
      if (failedPdfPages.length) {
        console.warn("Meeting report skipped PDF pages:", failedPdfPages);
        alert(
          `Meeting Report generated with ${failedPdfPages.length} skipped PDF page(s). Check console for details.`
        );
      }
    } catch (error) {
      const errMessage =
        error instanceof Error
          ? `${error.name}: ${error.message}`
          : String(error);
      console.error("Meeting report generation failed:", errMessage, error);
      alert(`Failed to generate Meeting Report. ${errMessage}`);
    } finally {
      setMeetingReportSections([]);
      setMeetingReportProgress("");
      setMeetingReportLoading(false);
    }
  };
  useEffect(() => {
    const isAllFieldsEmpty =
      !(selectedSeasonlist?.length ?? 0) &&
      !(selectedDivisionlist?.length ?? 0) &&
      !(selectedImprintlist?.length ?? 0) &&
      !(selectedIsbnsList?.length ?? 0) &&
      !(selectedTitlesList?.length ?? 0) &&
      !(selectedAccountList?.length ?? 0) &&
      !(selectedPaperCutOffDateList?.length ?? 0) &&
      !(selectedLdcList?.length ?? 0);
    setButtonDisabled(isAllFieldsEmpty);
  }, [
    selectedSeasonlist,
    selectedDivisionlist,
    selectedImprintlist,
    selectedIsbnsList,
    selectedTitlesList,
    selectedAccountList,
    selectedPaperCutOffDateList,
    selectedLdcList,
  ]);

  useEffect(() => {
    if (selectedSeasonlist?.length) {
      setValue("season", selectedSeasonlist);
    }
    if (selectedDivisionlist?.length) {
      setValue("division", selectedDivisionlist);
    }
    if (selectedImprintlist?.length) {
      setValue("imprint", selectedImprintlist);
    }
    if (selectedIsbnsList?.length) {
      setValue("isbn", selectedIsbnsList);
    }

    if (selectedTitlesList?.length) {
      setValue("title", selectedTitlesList);
    }
    if (selectedAccountList?.length) {
      setValue("accountName", selectedAccountList);
    }
    if (selectedPaperCutOffDateList?.length) {
      setValue("paperCutOffDate", selectedPaperCutOffDateList);
    }
    if (selectedLdcList?.length) {
      setValue("ldc", selectedLdcList);
    }
    return () => {
      dispatch(emptySEGMainPage());
    };
  }, []);
  const containerRef = useRef<HTMLDivElement | null>(null);



  const handleFilterClear = (e: any) => {
    e.preventDefault();
    dispatch(setscrolling(false));
    setTimeout(() => {
      dispatch(setscrolling(true));
    }, 50);
    // Clear form values and Redux state
    setValue("season", []);
    setValue("paperCutOffDate", []);
    setValue("ldc", []);
    setValue("division", []);
    setValue("imprint", []);
    setValue("isbn", []);
    setValue("title", []);
    setValue("accountName", []);
    dispatch(UpdateSelectedISBNS([]));
    dispatch(UpdateSelectedTitles([]));
    dispatch(UpdateSelectedSeason([]));
    dispatch(UpdateSelectedPaperCutOffDate([]));
    dispatch(UpdateSelectedPaperCutOffDateList([]));
    dispatch(UpdateSelectedLdc([]));
    dispatch(UpdateSelectedLdcList([]));
    dispatch(UpdateSelectedDivision([]));
    dispatch(UpdateSelectedImprint([]));
    dispatch(UpdateSelectedAccounts([]));
    // Reset page to 1 to trigger useEffect
    dispatch(resetSEGPage());
  };

  useEffect(() => {
    if (selectedSeasonlist?.length) {
      setSeason(selectedSeasonlist.map((season: any) => season.value));
    } else {
      setSeason([]);
    }
    if (selectedDivisionlist?.length) {
      setDivision(selectedDivisionlist.map((season: any) => season.value));
    } else {
      setDivision([]);
    }
    if (selectedImprintlist?.length) {
      setImprint(selectedImprintlist.map((season: any) => season.value));
    } else {
      setImprint([]);
    }
    if (selectedIsbnsList?.length) {
      console.log("under the if");
      setIsbn(selectedIsbnsList.map((season: any) => season.value));
    } else {
      setIsbn([]);
    }
    if (selectedPaperCutOffDateList?.length) {
      setPaperCutOffDate(selectedPaperCutOffDateList.map((date: any) => date.value));
    } else {
      setPaperCutOffDate([]);
    }
    console.log("selectedIsbnsList", selectedIsbnsList);
    console.log("setIsbn", isbn);
  }, [
    selectedSeasonlist,
    selectedPaperCutOffDateList,
    selectedLdcList,
    selectedDivisionlist,
    selectedImprintlist,
    selectedIsbnsList,
  ]);

  useEffect(() => {
    handleSegRecordsFilterFetch();
  }, [page, SegReducer.titleSortBy]);

  useEffect(() => {
    const watchedSeason = watch("season");
    const watchedPaperCutOffDate = watch("paperCutOffDate");
    const watchedLdc = watch("ldc");
    const watchedDivision = watch("division");
    const watchedIsbn = watch("isbn");
    const watchedImprint = watch("imprint");
    const watchedAccountName = watch("accountName");

    const seasonData = Array.isArray(watchedSeason)
      ? watchedSeason.map((data) => data.value)
      : [];

    const paperCutOffDateData = Array.isArray(watchedPaperCutOffDate)
      ? watchedPaperCutOffDate.map((data) => data.value)
      : [];

    const ldcDataForm = Array.isArray(watchedLdc)
      ? watchedLdc.map((data) => data.value)
      : [];

    const division = Array.isArray(watchedDivision)
      ? watchedDivision.map((data) => data.value)
      : [];

    const isbns = Array.isArray(watchedIsbn)
      ? watchedIsbn.map((data) => data.value)
      : [];

    const imprint = Array.isArray(watchedImprint)
      ? watchedImprint.map((data) => data.value)
      : [];
    const accountName = Array.isArray(watchedAccountName)
      ? watchedAccountName.map((data) => data.value)
      : [];

    const requestKey = JSON.stringify({
      seasonData,
      paperCutOffDateData,
      ldcDataForm,
      division,
      isbns,
      imprint,
      accountName,
    });
    if (lastFilterRequestKeyRef.current === requestKey) return;
    lastFilterRequestKeyRef.current = requestKey;

    handleSegRecordsFilterFetch();
    dispatch(
      fetchDivision({
        seasons: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataForm,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        accountName: accountName,
      })
    );
    dispatch(
      FetchSeason({
        seasons: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataForm,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        accountName: accountName,
      })
    );
    dispatch(
      fetchPaperCutOffDates({
        seasons: seasonData,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        accountName: accountName,
        ldc: ldcDataForm,
      })
    );
    dispatch(
      fetchLdcDates({
        seasons: seasonData,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        accountName: accountName,
        paperCutOffDate: paperCutOffDateData,
      })
    );
    dispatch(
      fetchImprint({
        seasons: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataForm,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        accountName: accountName,
      })
    );
    dispatch(
      fetchAccounts({
        data: {
          seasons: seasonData,
          paperCutOffDate: paperCutOffDateData,
          ldc: ldcDataForm,
          divisions: division,
          isbns: isbns,
          imprint: imprint,
          accountName: accountName,
        },
        searchStr: "",
        page: 1,
        limit: 10,
        oldAccounts: oldAccounts,
      })
    );
    dispatch(
      fetchIsbnList({
        prevSeason: selectedSeason,
        prevDivision: selectedDivision,
        prevImprint: selectedImprint,
        prevPaperCutOffDate: selectedPaperCutOffDate,
        prevLdc: selectedLdc,
        oldEans: oldISBNS,
        seasons: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataForm,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        limit: isbnLimit,
        skip: isbnLimit * isbnSkip,
        sortBy: SegReducer.titleSortBy,
        selectedData: watchedIsbn?.length
          ? watchedIsbn.map((isbn) => isbn.label)
          : [],
      })
    );

    dispatch(UpdateSelectedISBNS(isbns));
    dispatch(UpdateSelectedTitles(isbns));
    dispatch(UpdateSelectedSeason(seasonData));
    dispatch(UpdateSelectedPaperCutOffDate(paperCutOffDateData));
    dispatch(UpdateSelectedLdc(ldcDataForm));
    dispatch(UpdateSelectedDivision(division));
    dispatch(UpdateSelectedImprint(imprint));
    dispatch(UpdateSelectedAccounts(accountName));
    dispatch(UpdateSelectedISBNSList(watchedIsbn));
    dispatch(UpdateSelectedTitlesList(watch("title")));
    dispatch(UpdateSelectedSeasonList(watchedSeason));
    dispatch(UpdateSelectedPaperCutOffDateList(watchedPaperCutOffDate));
    dispatch(UpdateSelectedLdcList(watchedLdc));
    dispatch(UpdateSelectedDivisionList(watchedDivision));
    dispatch(UpdateSelectedImprintList(watchedImprint));
    dispatch(UpdateSelectedAccountList(watchedAccountName));
  }, [
    watch("season"),
    watch("paperCutOffDate"),
    watch("ldc"),
    watch("division"),
    watch("imprint"),
    watch("isbn"),
    watch("accountName"),
  ]);

  const options = SeasonData.map((SeasonData) => ({
    value: SeasonData.SEASON ?? "",
    label: SeasonData.SEASON ?? "",
  }));
  // Helper function to parse date from various formats (M/D/YYYY, MM/DD/YYYY, M/DD/YYYY)
  const parseDateForSorting = (dateStr: string): Date | null => {
    if (!dateStr || dateStr.trim() === "") return null;
    // Split by '/' to get month, day, year
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(month) || isNaN(day) || isNaN(year)) return null;
    return new Date(year, month - 1, day);
  };

  const PaperCutOffDateOption = paperCutOffDateData
    .map((paperCutOffDate: any) => {
      const dateValue = paperCutOffDate.PAPER_CUT_OFF_DATE ?? "";
      return {
        value: dateValue,
        label: dateValue === "" ? "-" : dateValue,
        sortDate: parseDateForSorting(dateValue),
      };
    })
    .sort((a, b) => {
      // Handle blank values - put them at the end
      if (a.sortDate === null && b.sortDate === null) return 0;
      if (a.sortDate === null) return 1; // null dates go to end
      if (b.sortDate === null) return -1; // null dates go to end
      // Sort in descending order (newest first)
      return b.sortDate.getTime() - a.sortDate.getTime();
    })
    .map(({ value, label }) => ({
      value,
      label,
    }));
  const LdcOption = ldcData
    .map((ldcItem: { LDC_DATE?: string }) => {
      const dateValue = ldcItem.LDC_DATE ?? "";
      return {
        value: dateValue,
        label: dateValue === "" ? "-" : dateValue,
        sortDate: parseDateForSorting(dateValue),
      };
    })
    .sort((a: { sortDate: Date | null }, b: { sortDate: Date | null }) => {
      if (a.sortDate === null && b.sortDate === null) return 0;
      if (a.sortDate === null) return 1;
      if (b.sortDate === null) return -1;
      return b.sortDate.getTime() - a.sortDate.getTime();
    })
    .map(({ value, label }: { value: string; label: string }) => ({
      value,
      label,
    }));
  const DivisionOption = divisionData.map((Division) => ({
    value: Division.division ?? "",
    label: Division.division ?? "",
  }));
  const ImprintOption = imprintData.map((imprint) => ({
    value: imprint.IMPRINT,
    label: imprint.IMPRINT,
  }));
  const accountOptions = accountData.accounts?.length
    ? accountData.accounts.map((account) => ({
      value: account._id,
      label: account.ACCOUNT_NAME,
    }))
    : [];
  // const handleRowClick = (row: any, index: number) => {
  //   if(!isLoading){
  //     dispatch(setSelectedRowIndex(index));
  //     dispatch(setSelectedSeg(row._id));
  //     navigate(`/details/${row._id}`);
  //   }
  // };
  let doubleClick = 0;
  const handleRowClick = (row: any, index: number) => {
    console.log("serial", index)

    doubleClick++;
    setTimeout(() => {
      if (doubleClick === 2) {
        dispatch(setSelectedRowIndex(index));
        dispatch(setSelectedSeg(row._id));
        localStorage.setItem("segId", row._id);
        localStorage.setItem("clickedIsbn", row.EAN);

        dispatch(setNoSegId(false));
        dispatch(setLocal(true));
        dispatch(setRenderSeason(true))
        dispatch(setResetSeason(false))
        dispatch(resetSkipForOtis())
        const page = Math.floor((index) / 15);
        // dispatch(setSkip(page));
        dispatch(resetIsbns())
        dispatch(setIsbnStringForOtis(""))
        localStorage.removeItem("savedFilterState");
        localStorage.removeItem("saveFlag");
        dispatch(setClickedIsbn(row.EAN));




        navigate(`/details/${row._id}/${row.SEASON}`);
        doubleClick = 0;
        dispatch(UpdatetableCond(true));
        dispatch(handleLocalClear(true));
      } else if (doubleClick === 1) {
      } else doubleClick = 0;
    }, 250);
  };
  useEffect(() => {
    if (SegData && SegData.length > 0 && selectedRowIndex === 0) {
      dispatch(setSelectedRowIndex(0));
      dispatch(setSelectedSeg(SegData[0]._id));
    }
  }, [SegData]);

  const changeIsbnInfo = (event: any) => {
    if (event.target.name === "title") {
      const titleIsbns = watch("title").map((title: any) => title.value);
      const isbnFilteredData =
        isbn_number_options?.filter((isbn) =>
          titleIsbns.includes(isbn.value)
        ) || [];
      setValue("isbn", isbnFilteredData);
      dispatch(resetSkip())

    }
    // setting the isbn title if isbn number is changed
    else if (event.target.name === "isbn") {
      const isbnsList = watch("isbn").map((isbn: any) => isbn.value);
      const titleFilteredData =
        isbn_title_options?.filter((title) =>
          isbnsList.includes(title.value)
        ) || [];
      setValue("title", titleFilteredData);
      dispatch(resetSkip())

    }
  };

  const handleSegRecordsFilterFetch = () => {
    const seasonData = Array.isArray(watch("season"))
      ? watch("season").map((data) => data.value)
      : [];

    const paperCutOffDateData = Array.isArray(watch("paperCutOffDate"))
      ? watch("paperCutOffDate").map((data) => data.value)
      : [];

    const ldcDataPayload = Array.isArray(watch("ldc"))
      ? watch("ldc").map((data) => data.value)
      : [];

    const division = Array.isArray(watch("division"))
      ? watch("division").map((data) => data.value)
      : [];

    const isbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const imprint = Array.isArray(watch("imprint"))
      ? watch("imprint").map((data) => data.value)
      : [];

    const accountName = Array.isArray(watch("accountName"))
      ? watch("accountName").map((data: OptionType) => data.value)
      : [];

    const SegIds = SegData.map((data) => data._id);

    dispatch(
      FetchSegRecord({
        sortBy: SegReducer.titleSortBy,
        page: page,
        limit: limit,
        season: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataPayload,
        Division: division,
        Imprint: imprint,
        accountName: accountName,
        prevAccounts: selectedAccounts,
        SegIds: SegIds,
        isbns: isbns,
        prevSeason: selectedSeason,
        prevPaperCutOffDate: selectedPaperCutOffDate,
        prevLdc: selectedLdc,
        prevDivision: selectedDivision,
        prevImprint: selectedImprint,
        prevIsbns: selectedIsbns,
      })
    );
    dispatch(UpdateSelectedISBNSList(watch("isbn")));
    dispatch(UpdateSelectedISBNS(isbns));
    dispatch(UpdateSelectedTitlesList(watch("title")));
    dispatch(UpdateSelectedTitles(isbns));
    dispatch(UpdateSelectedSeasonList(watch("season")));
    dispatch(UpdateSelectedSeason(seasonData));
    dispatch(UpdateSelectedPaperCutOffDateList(watch("paperCutOffDate")));
    dispatch(UpdateSelectedPaperCutOffDate(paperCutOffDateData));
    dispatch(UpdateSelectedLdcList(watch("ldc")));
    dispatch(UpdateSelectedLdc(ldcDataPayload));
    dispatch(UpdateSelectedDivisionList(watch("division")));
    dispatch(UpdateSelectedDivision(division));
    dispatch(UpdateSelectedImprintList(watch("imprint")));
    dispatch(UpdateSelectedImprint(imprint));
    dispatch(UpdateSelectedAccountList(watch("accountName")));
    dispatch(UpdateSelectedAccounts(accountName));
  };
  const tableStyles = {
    sx: {
      "& thead": {
        position: "sticky",
        top: 0,
        zIndex: bgElement ? 0 : 1,
      },
    },
  };
  const reorderOptions = (selectedValues: any, options: any) => {
    if (!selectedValues || selectedValues.length === 0) {
    return options;
    }
    const selectedIds = selectedValues.map((selected: any) => selected.value);
    const filteredOptions = options.filter(
      (option: any) => !selectedIds.includes(option.value)
    );
    return [...selectedValues, ...filteredOptions];
  };

  useEffect(() => {
    // Initial ISBN list fetch is already handled in the filters effect.
    // Skip this first run to prevent duplicate fetchIsbnList call on mount.
    if (!hasSkippedInitialCommonIsbnFetchRef.current) {
      hasSkippedInitialCommonIsbnFetchRef.current = true;
      return;
    }
    commonIsbnfunction();
  }, [isbnsString, isbnSkip]);

  const commonIsbnfunction = () => {
    // alert("segmain")
    const seasonData = Array.isArray(watch("season"))
      ? watch("season").map((data) => data.value)
      : [];

    const paperCutOffDateData = Array.isArray(watch("paperCutOffDate"))
      ? watch("paperCutOffDate").map((data) => data.value)
      : [];

    const ldcDataPayload = Array.isArray(watch("ldc"))
      ? watch("ldc").map((data) => data.value)
      : [];

    const division = Array.isArray(watch("division"))
      ? watch("division").map((data) => data.value)
      : [];
    const isbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const imprint = Array.isArray(watch("imprint"))
      ? watch("imprint").map((data) => data.value)
      : [];
    dispatch(
      fetchIsbnList({
        seasons: seasonData,
        paperCutOffDate: paperCutOffDateData,
        ldc: ldcDataPayload,
        divisions: division,
        isbns: isbns,
        imprint: imprint,
        prevSeason: selectedSeason,
        prevDivision: selectedDivision,
        prevImprint: selectedImprint,
        prevPaperCutOffDate: selectedPaperCutOffDate,
        prevLdc: selectedLdc,
        oldEans: [],
        limit: isbnLimit,
        // skip: (isbnSkip-1) * isbnLimit,
        // skip: Math.max(0, (isbnSkip - 1) * isbnLimit),
        skip: isbnLimit * isbnSkip,
        selectedData: watch("isbn")?.length
          ? watch("isbn").map((isbn) => isbn.label)
          : [],
        searchStr: isbnsString,
        sortBy: SegReducer.titleSortBy
      })
    );
  };
  const isbnElement = document.getElementById("isbn-selector");
  const titleElement = document.getElementById("title-selector");
  const seasonElement = document.getElementById("season-selector");
  const divisionElement = document.getElementById("division-selector");
  const imprintElement = document.getElementById("imprint-selector");
  useEffect(() => {
    if (isbnElement) {
      const inner_1st_Div = isbnElement.querySelector("div > div");
      // Find the inner div within the outer div

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    if (titleElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = titleElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }
    if (seasonElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = seasonElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }
    if (divisionElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = divisionElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }
    if (imprintElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = imprintElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    // if (multiValuContainer[0] || multiValuContainer[1]) {
    //   multiValuContainer[0].scrollLeft = multiValuContainer[0].scrollWidth;
    //   multiValuContainer[1].scrollLeft = multiValuContainer[1].scrollWidth;
    // }
    // },[multiValuContainer[0]?.scrollWidth])
  }, [
    isbnElement?.querySelector("div > div")?.querySelector("div > div")?.scrollWidth,
    titleElement?.querySelector("div > div")?.querySelector("div > div")?.scrollWidth,
    !accountData.isLoading,
  ]);
  function getKeyByValue(obj: any, value: any) {
    return Object.keys(obj).find((key) => obj[key] === value);
  }

  function debounce<T extends (...args: any[]) => void>(func: T, delay: number) {
    let timer: ReturnType<typeof setTimeout>;
    return (...args: Parameters<T>) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }


  const debouncedDispatch = useMemo(() =>
    debounce((value: string) => {
      dispatch(setIsbnString(value));
      dispatch(resetSkip());
    }, 500),
    [dispatch]);


  const CommonHeader = ({ column }: any) => {
    const titleKey = getKeyByValue(SegRecords, column.columnDef.header);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span>{column.columnDef.header}</span>
        <span className="mt-1">
          {titleKey === SegReducer.titleSortBy.heading &&
            SegReducer.titleSortBy.sortType === "desc" ? (
            <FaSortUp
              className="cursor-pointer"
              title={`sort ${column.columnDef.header} by ascending`}
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "asc",
                    heading: titleKey,
                  })
                );
                dispatch(resetSEGPage());
              }}
            />
          ) : titleKey === SegReducer.titleSortBy.heading &&
            SegReducer.titleSortBy.sortType === "asc" ? (
            <FaSortDown
              title={`sort ${column.columnDef.header} by descending`}
              className="cursor-pointer"
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "desc",
                    heading: titleKey,
                  })
                );
                dispatch(resetSEGPage());
              }}
            />
          ) : (
            <FaSort
              title={`sort ${column.columnDef.header} by ascending`}
              className="cursor-pointer"
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "asc",
                    heading: titleKey,
                  })
                );
                dispatch(resetSEGPage());
              }}
            />
          )}
        </span>
      </div>
    );
  };

  const renderPaginationSkeletonCell = (width: string | number = "80%") => (
    <Skeleton variant="rounded" width={width} height={14} />
  );

  const showInitialSkeleton = isLoading && SegData.length === 0;
  const showInlineBusyState = LoadingTest || meetingReportLoading;
  const showPaginationLoader = isLoading && SegData.length > 0 && page > 1;
  const paginationSkeletonRows = useMemo(
    () =>
      showPaginationLoader
        ? Array.from({ length: 15 }).map((_, index) => ({
            _id: `pagination-skeleton-${index}`,
            __paginationSkeleton: true,
          }))
        : [],
    [showPaginationLoader]
  );
  const segDataWithPaginationSkeleton = useMemo(
    () => [...SegData, ...paginationSkeletonRows],
    [SegData, paginationSkeletonRows]
  );

  return (
    <div className="flex p-4 h-[80vh] overflow-auto sm:overflow-hidden">
      <div className="font-poppins w-full" ref={containerRef}>
        {showInlineBusyState && (
          <div className="mb-2 rounded-md border border-red-100 bg-red-50 px-3 py-2 text-xs font-semibold text-[#e31c23]">
            {LoadingTest
              ? "Preparing export file..."
              : meetingReportProgress || "Generating meeting report..."}
          </div>
        )}
        {showInitialSkeleton ? (
          <SegSummarySkeleton />
        ) : (
          <>
            <CommonDataTable
            muiTableProps={tableStyles}
            tableCursor="pointer"
            maxHeight="65vh"
            hasMore={hasMore}
            enableRowStyling={true}
            FetchCallbackFun={() => dispatch(UpdatePagination())}
            tableHeaders={SegRecords}
            className={` h-screen `}
            data={segDataWithPaginationSkeleton}
            enableGlobalFilter={false}
            enableBottomToolbar={false}
            showRowNumbers
            scrollable
            // pageSize={SegData?.length }
            // callback={handleRowClick}
            callback={(rowData, rowIndex) => {
              if ((rowData as any)?.__paginationSkeleton) return;
              handleRowClick(rowData, rowIndex);
            }}
            selectedIndex={selectedRowIndex}
            colSizes={[100, 100, 100, 100, 100]}
            // nextCallback={()=>}
            // customActionButton={()=>{}}
            enableTopToolbar
            changeSelectedColumnDataDesign={[
              "PUB_DATE",
              "RELEASE_DATE",
              "PAPER_CUT_OFF",
              "LDC",
              "FULL_TITLE",
              "totalPubGoal",
              "totalCurrentEst",
              "totalInitOrd",
              "US_PRICE",
              "estimatePubGoal",
              "EAN",
              "SEASON",
              "GROUP_1",
              "TESTIMPRINTFROMHNA",
              "AUTHOR_1",
              "FORMAT",
            ]}
            changedDataCellColumn={(header: any, accessor: string) => {
              if (
                accessor === "PUB_DATE" ||
                accessor === "RELEASE_DATE" ||
                accessor === "PAPER_CUT_OFF" ||
                accessor === "LDC"
              ) {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => (
                    <div>
                      {row.original?.__paginationSkeleton
                        ? renderPaginationSkeletonCell("75%")
                        : row.original[accessor]?.length > 2
                        ? moment(row.original[accessor]).format("MM/DD/YYYY")
                        : " - "}
                    </div>
                  ),
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                };
              } else if (accessor === "FULL_TITLE")
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => (
                    <div className="flex flex-wrap px-1 w-[300px] items-center text-center max-w-[300px]">
                      {row.original?.__paginationSkeleton
                        ? renderPaginationSkeletonCell("95%")
                        : row.original[accessor]}
                    </div>
                  ),
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              else if (accessor === "totalPubGoal") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    if (row.original?.__paginationSkeleton) {
                      return (
                        <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                          {renderPaginationSkeletonCell("70%")}
                        </div>
                      );
                    }
                    const value =
                      typeof row?.original?.totalPubGoal === "number"
                        ? row?.original?.totalPubGoal
                        : row?.original?.totalPubGoal?.["$numberDecimal"];
                    const displayValue =
                      value || value === 0 ? formatNumber(value) || `${value}` : "-";
                    return (
                      <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                        {/* {row.original.totalPubGoal ? `${row.original.totalPubGoal['$numberDecimal']}` : '-' } */}
                        {displayValue}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (accessor === "totalCurrentEst") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    if (row.original?.__paginationSkeleton) {
                      return (
                        <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                          {renderPaginationSkeletonCell("70%")}
                        </div>
                      );
                    }
                    const value =
                      typeof row?.original?.totalCurrentEst === "number"
                        ? row?.original?.totalCurrentEst
                        : row?.original?.totalCurrentEst?.["$numberDecimal"];
                    const displayValue =
                      value || value === 0 ? formatNumber(value) || `${value}` : "-";
                    return (
                      <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center ">
                        {/* {row.original.totalCurrentEst ? `${row.original.totalCurrentEst['$numberDecimal']}` : '-' } */}
                        {displayValue}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (accessor === "totalInitOrd") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    if (row.original?.__paginationSkeleton) {
                      return (
                        <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                          {renderPaginationSkeletonCell("70%")}
                        </div>
                      );
                    }
                    const value = row.original.totalInitOrd;
                    const rawValue =
                      typeof value === "object" && "$numberDecimal" in value
                        ? value.$numberDecimal
                        : value ?? "-";
                    return (
                      <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                        {formatNumber(rawValue) || rawValue}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (accessor === "estimatePubGoal") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    if (row.original?.__paginationSkeleton) {
                      return (
                        <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                          {renderPaginationSkeletonCell("70%")}
                        </div>
                      );
                    }
                    const value = row?.original?.estimatePubGoal;
                    const displayValue =
                      value === null || value === undefined || value === " "
                        ? "-"
                        : formatNumber(value) || value;
                    return (
                      <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center ">
                        {/* {
                      row.original.estimatePubGoal && row.original.estimatePubGoal["$numberDecimal"] !== null && row.original.estimatePubGoal["$numberDecimal"] !== ""
                        ? `${row.original.estimatePubGoal["$numberDecimal"]}`
                        : "-"
                    } */}
                        {displayValue}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (accessor === "US_PRICE") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    // const price = parseFloat(row.original.US_PRICE).toFixed(2);
                    return (
                      <div className="whitespace-nowrap max-w-[300px] overflow-y-auto flex items-center justify-center">
                        {row.original?.__paginationSkeleton
                          ? renderPaginationSkeletonCell("60%")
                          : formatCurrency(row.original.US_PRICE)}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (accessor == "AUTHOR_1") {
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => {
                    // const price = parseFloat(row.original.US_PRICE).toFixed(2);
                    return (
                      <div className="w-[140px] ">
                        {row.original?.__paginationSkeleton
                          ? renderPaginationSkeletonCell("90%")
                          : row.original[accessor]}
                      </div>
                    );
                  },
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              } else if (
                accessor == "EAN" ||
                accessor == "SEASON" ||
                accessor == "GROUP_1" ||
                accessor == "TESTIMPRINTFROMHNA" ||
                accessor == "FORMAT"
              )
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => (
                    <div className="w-[100px] ">
                      {row.original?.__paginationSkeleton
                        ? renderPaginationSkeletonCell("85%")
                        : row.original[accessor]}
                    </div>
                  ),
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              return {
                accessorKey: accessor,
                header: header,
                Cell: ({ row }: { row: any }) =>
                  row.original?.__paginationSkeleton ? (
                    <div className="flex items-center justify-center">
                      {renderPaginationSkeletonCell("75%")}
                    </div>
                  ) : (
                    <div>{row.original[accessor] ?? "-"}</div>
                  ),
              };
            }}
            topToolbar={({ table }) => (
              <form className="flex flex-col p-2 w-full">
                {/* First row: 4 filters */}
                <div className={`flex flex-wrap items-end gap-x-2 gap-y-1 w-full mb-1 ${!bgElement ? "z-10" : ""}`}>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">SEASON</p>
                    <div className="grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        name="season"
                        control={control}
                        render={({ field }) => {
                          const reorderedOptions = reorderOptions(
                            field.value,
                            options
                          );
                          return (
                            <div className="w-full">
                              <Select
                                id="season-selector"
                                classNamePrefix={"custom-select"}
                                hideSelectedOptions={false}
                                {...field}
                                placeholder="Select Season"
                                options={reorderedOptions}
                                isMulti
                                onChange={(e) => {
                                  field.onChange(e);
                                  dispatch(resetSkip());
                                }}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                value={selectedSeasonlist}
                                className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                                components={{
                                  MultiValueContainer: (props) => (
                                    <components.MultiValueContainer {...props}>
                                      <div className="flex">{props.children}</div>
                                    </components.MultiValueContainer>
                                  ),
                                  LoadingIndicator: () =>
                                    seasonIsLoading ? <CustomSelectLoader /> : null,
                                }}
                                isLoading={seasonIsLoading}
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    pointerEvents: isLoading ? "none" : "auto",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    position: `${watch("season")?.length ? "relative" : "absolute"}`,
                                    pointerEvents: isLoading ? "none" : "auto",
                                    left: 6,
                                    marginRight: "10px",
                                    caretColor: isLoading ? "transparent" : "auto",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor:
                                      state.isSelected || state.isFocused
                                        ? "#E6E6E6"
                                        : "",
                                    color: state.isSelected ? "black" : "black",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    minWidth: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                    position: "absolute",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                  }),
                                  valueContainer: (provided) => ({
                                    position: "relative",
                                    maxWidth: "100%",
                                    width: "100%",
                                    paddingLeft: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "32px",
                                    paddingRight: "8px",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    minWidth: "50px",
                                    boxSizing: "border-box",
                                    ...(isFirefox && {
                                      scrollbarWidth: "thin",
                                    }),
                                  }),
                                  control: (provided) => ({
                                    display: "flex",
                                    height: "32px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }),
                                  menuList: (provided) => ({
                                    maxHeight: "200px",
                                    overflow: "hidden",
                                    overflowY: "auto",
                                  }),
                                  clearIndicator: () => ({
                                    marginLeft: "15px",
                                    marginTop: "5px",
                                    color: "gray",
                                  }),
                                }}
                              />
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">PAPER CUT OFF DATE</p>
                    <div className="grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        name="paperCutOffDate"
                        control={control}
                        render={({ field }) => {
                          const reorderedOptions = reorderOptions(
                            field.value,
                            PaperCutOffDateOption
                          );
                          return (
                            <div className="w-full">
                              <Select
                                id="paper-cut-off-date-selector"
                                classNamePrefix={"custom-select"}
                                hideSelectedOptions={false}
                                {...field}
                                placeholder="Select Paper Cut Off Date"
                                options={reorderedOptions}
                                isMulti
                                onChange={(e) => {
                                  field.onChange(e);
                                  dispatch(resetSkip());
                                }}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                value={selectedPaperCutOffDateList}
                                className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                                components={{
                                  MultiValueContainer: (props) => (
                                    <components.MultiValueContainer {...props}>
                                      <div className="flex">{props.children}</div>
                                    </components.MultiValueContainer>
                                  ),
                                  LoadingIndicator: () =>
                                    paperCutOffDateIsLoading ? <CustomSelectLoader /> : null,
                                }}
                                isLoading={paperCutOffDateIsLoading}
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    pointerEvents: isLoading ? "none" : "auto",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    position: `${watch("paperCutOffDate")?.length ? "relative" : "absolute"}`,
                                    pointerEvents: isLoading ? "none" : "auto",
                                    left: 6,
                                    marginRight: "10px",
                                    caretColor: isLoading ? "transparent" : "auto",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor:
                                      state.isSelected || state.isFocused
                                        ? "#E6E6E6"
                                        : "",
                                    color: state.isSelected ? "black" : "black",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    minWidth: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                    position: "absolute",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                  }),
                                  valueContainer: (provided) => ({
                                    position: "relative",
                                    maxWidth: "100%",
                                    width: "100%",
                                    paddingLeft: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "32px",
                                    paddingRight: "8px",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    minWidth: "50px",
                                    boxSizing: "border-box",
                                    ...(isFirefox && {
                                      scrollbarWidth: "thin",
                                    }),
                                  }),
                                  control: (provided) => ({
                                    display: "flex",
                                    height: "32px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }),
                                  menuList: (provided) => ({
                                    maxHeight: "200px",
                                    overflow: "hidden",
                                    overflowY: "auto",
                                  }),
                                  clearIndicator: () => ({
                                    marginLeft: "15px",
                                    marginTop: "5px",
                                    color: "gray",
                                  }),
                                }}
                              />
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">LDC</p>
                    <div className="grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        name="ldc"
                        control={control}
                        render={({ field }) => {
                          const reorderedOptions = reorderOptions(
                            field.value,
                            LdcOption
                          );
                          return (
                            <div className="w-full">
                              <Select
                                id="ldc-selector"
                                classNamePrefix={"custom-select"}
                                hideSelectedOptions={false}
                                {...field}
                                placeholder="Select LDC"
                                options={reorderedOptions}
                                isMulti
                                onChange={(e) => {
                                  field.onChange(e);
                                  dispatch(resetSkip());
                                }}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                value={selectedLdcList}
                                className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                                components={{
                                  MultiValueContainer: (props) => (
                                    <components.MultiValueContainer {...props}>
                                      <div className="flex">{props.children}</div>
                                    </components.MultiValueContainer>
                                  ),
                                  LoadingIndicator: () =>
                                    ldcIsLoading ? <CustomSelectLoader /> : null,
                                }}
                                isLoading={ldcIsLoading}
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    pointerEvents: isLoading ? "none" : "auto",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    position: `${watch("ldc")?.length ? "relative" : "absolute"}`,
                                    pointerEvents: isLoading ? "none" : "auto",
                                    left: 6,
                                    marginRight: "10px",
                                    caretColor: isLoading ? "transparent" : "auto",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor:
                                      state.isSelected || state.isFocused
                                        ? "#E6E6E6"
                                        : "",
                                    color: state.isSelected ? "black" : "black",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    minWidth: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                    position: "absolute",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                  }),
                                  valueContainer: (provided) => ({
                                    position: "relative",
                                    maxWidth: "100%",
                                    width: "100%",
                                    paddingLeft: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "32px",
                                    paddingRight: "8px",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    minWidth: "50px",
                                    boxSizing: "border-box",
                                    ...(isFirefox && {
                                      scrollbarWidth: "thin",
                                    }),
                                  }),
                                  control: (provided) => ({
                                    display: "flex",
                                    height: "32px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }),
                                  menuList: (provided) => ({
                                    maxHeight: "200px",
                                    overflow: "hidden",
                                    overflowY: "auto",
                                  }),
                                  clearIndicator: () => ({
                                    marginLeft: "15px",
                                    marginTop: "5px",
                                    color: "gray",
                                  }),
                                }}
                              />
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">DIVISION</p>
                    <div className="w-full grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        name="division"
                        control={control}
                        render={({ field }) => {
                          const reorderedOptions = reorderOptions(
                            field.value,
                            DivisionOption
                          );
                          return (
                            <Select
                              id="division-selector"
                              classNamePrefix={"custom-select"}
                              hideSelectedOptions={false}
                              placeholder="Select Division"
                              {...field}
                              options={reorderedOptions}
                              isMulti
                              onChange={(e) => {
                                field.onChange(e);
                                dispatch(resetSkip());
                              }}
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              value={selectedDivisionlist}
                              className="border border-solid w-full border-neutral-300 font-poppins rounded-lg lg:text-[14px] sm:text-[9.9px]"
                              components={{
                                MultiValueContainer: (props) => (
                                  <components.MultiValueContainer {...props}>
                                    <div className="flex">{props.children}</div>
                                  </components.MultiValueContainer>
                                ),
                                LoadingIndicator: () =>
                                  divisionIsLoading ? <CustomSelectLoader /> : null,
                              }}
                              isLoading={divisionIsLoading}
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  pointerEvents: isLoading ? "none" : "auto",
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  position: `${watch("division")?.length ? "relative" : "absolute"}`,
                                  pointerEvents: isLoading ? "none" : "auto",
                                  left: 6,
                                  marginRight: "10px",
                                  caretColor: isLoading ? "transparent" : "auto",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor:
                                    state.isSelected || state.isFocused
                                      ? "#E6E6E6"
                                      : "",
                                  color: state.isSelected ? "black" : "black",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: "6px",
                                  minWidth: "none",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                  position: "absolute",
                                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                }),
                                valueContainer: (provided) => ({
                                  position: "relative",
                                  maxWidth: "100%",
                                  width: "100%",
                                  paddingLeft: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "32px",
                                  paddingRight: "8px",
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                  minWidth: "50px",
                                  boxSizing: "border-box",
                                  ...(isFirefox && {
                                    scrollbarWidth: "thin",
                                  }),
                                }),
                                control: (provided) => ({
                                  display: "flex",
                                  height: "32px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }),
                                menuList: (provided) => ({
                                  maxHeight: "200px",
                                  overflow: "hidden",
                                  overflowY: "auto",
                                }),
                                clearIndicator: () => ({
                                  marginLeft: "15px",
                                  marginTop: "5px",
                                  color: "gray",
                                }),
                              }}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-[140px] max-w-[280px] pr-3">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">IMPRINT</p>
                    <div className="w-full grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        name="imprint"
                        control={control}
                        render={({ field }) => {
                          const reorderedOptions = reorderOptions(
                            field.value,
                            ImprintOption
                          );
                          return (
                            <Select
                              id="imprint-selector"
                              classNamePrefix={"custom-select"}
                              hideSelectedOptions={false}
                              placeholder="Select Imprint"
                              {...field}
                              options={reorderedOptions}
                              isMulti
                              onChange={(e) => {
                                field.onChange(e);
                                dispatch(resetSkip());
                              }}
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              value={selectedImprintlist}
                              className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                              components={{
                                MultiValueContainer: (props) => (
                                  <components.MultiValueContainer {...props}>
                                    <div className="flex">{props.children}</div>
                                  </components.MultiValueContainer>
                                ),
                                LoadingIndicator: () =>
                                  imprintIsLoading ? <CustomSelectLoader /> : null,
                              }}
                              isLoading={imprintIsLoading}
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  pointerEvents: isLoading ? "none" : "auto",
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  position: `${watch("imprint")?.length ? "relative" : "absolute"}`,
                                  pointerEvents: isLoading ? "none" : "auto",
                                  left: 6,
                                  marginRight: "10px",
                                  caretColor: isLoading ? "transparent" : "auto",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: "6px",
                                  minWidth: "none",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor:
                                    state.isSelected || state.isFocused
                                      ? "#E6E6E6"
                                      : "",
                                  color: state.isSelected ? "black" : "black",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                  position: "absolute",
                                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                }),
                                valueContainer: (provided) => ({
                                  position: "relative",
                                  maxWidth: "100%",
                                  width: "100%",
                                  paddingLeft: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "32px",
                                  paddingRight: "8px",
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                  minWidth: "50px",
                                  boxSizing: "border-box",
                                  ...(isFirefox && {
                                    scrollbarWidth: "thin",
                                  }),
                                }),
                                control: (provided) => ({
                                  display: "flex",
                                  height: "32px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }),
                                menuList: (provided) => ({
                                  maxHeight: "200px",
                                  overflow: "hidden",
                                  overflowY: "auto",
                                }),
                                clearIndicator: () => ({
                                  marginLeft: "15px",
                                  marginTop: "5px",
                                  color: "gray",
                                }),
                              }}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Second row: remaining filters + Export + Clear All */}
                <div className={`flex flex-wrap items-end gap-x-2 gap-y-1 w-full ${!bgElement ? "z-10" : ""}`}>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">ISBN</p>
                    <div className="w-full grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        control={control}
                        name="isbn"
                        rules={{
                          onChange: changeIsbnInfo,
                          required: "ISBN is required",
                        }}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                        }) => {
                          const reorderedOptions = reorderOptions(
                            value,
                            isbn_number_options
                          );
                          return (
                            <div className="relative flex flex-col md:w-full">
                              <Select
                                classNamePrefix={"custom-select"}
                                hideSelectedOptions={false}
                                placeholder={"Select ISBN"}
                                onMenuScrollToBottom={() => {
                                  if (hasMore) {
                                    dispatch(updateIsbnSkip());
                                  }
                                }}
                                isMulti
                                onInputChange={(value) => {
                                  debouncedDispatch(value);
                                }}
                                onFocus={() => {
                                  dispatch(resetSkip());
                                }}
                                onMenuClose={() => {
                                  dispatch(setIsbnState(false));
                                }}
                                ref={ref}
                                id="isbn-selector"
                                name={name}
                                value={selectedIsbnsList}
                                noOptionsMessage={() => "ISBN not found"}
                                components={{
                                  MultiValueContainer: (props) => (
                                    <components.MultiValueContainer {...props}>
                                      <div className="flex">{props.children}</div>
                                    </components.MultiValueContainer>
                                  ),
                                  LoadingIndicator: () =>
                                    isbnIsLoading ? <CustomSelectLoader /> : null,
                                }}
                                isLoading={isbnIsLoading}
                                className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    pointerEvents: isLoading ? "none" : "auto",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    position: `${watch("isbn")?.length ? "relative" : "absolute"}`,
                                    pointerEvents: isLoading ? "none" : "auto",
                                    left: 6,
                                    marginRight: "10px",
                                    caretColor: isLoading ? "transparent" : "auto",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor:
                                      state.isSelected || state.isFocused
                                        ? "#E6E6E6"
                                        : "",
                                    color: state.isSelected ? "black" : "black",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    minWidth: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                    position: "absolute",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: isLoading ? -1 : 1050,
                                  }),
                                  valueContainer: (provided) => ({
                                    position: "relative",
                                    maxWidth: "100%",
                                    width: "100%",
                                    paddingLeft: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "32px",
                                    paddingRight: "8px",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    minWidth: "50px",
                                    boxSizing: "border-box",
                                    ...(isFirefox && {
                                      scrollbarWidth: "thin",
                                    }),
                                  }),
                                  control: (provided) => ({
                                    display: "flex",
                                    height: "32px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }),
                                  menuList: (provided) => ({
                                    maxHeight: "200px",
                                    overflow: "hidden",
                                    overflowY: "auto",
                                  }),
                                  clearIndicator: () => ({
                                    marginLeft: "15px",
                                    marginTop: "5px",
                                    color: "gray",
                                  }),
                                }}
                                onChange={(selectedOptions) => onChange(selectedOptions)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                options={reorderedOptions}
                              />
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-[140px] max-w-[280px]">
                    <p className="text-[#e31c23] font-semibold text-xs mb-0.5 leading-tight">TITLE</p>
                    <div className="w-full grid grid-cols-1 custom-scrollbar-wrapper">
                      <Controller
                        control={control}
                        name="title"
                        rules={{
                          onChange: changeIsbnInfo,
                          required: "Title is required",
                        }}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                        }) => {
                          const reorderedOptions = reorderOptions(
                            value,
                            isbn_title_options
                          );
                          return (
                            <Select
                              classNamePrefix={"custom-select"}
                              hideSelectedOptions={false}
                              placeholder={"Select Title"}
                              onMenuScrollToBottom={() => {
                                if (hasMore) {
                                  dispatch(updateIsbnSkip());
                                }
                              }}
                              isMulti
                              onInputChange={(value, { action }) => {
                                if (action !== "input-change") return value;
                                debouncedDispatch(value);
                                return value;
                              }}
                              onMenuClose={() => {
                                dispatch(setIsbnState(false));
                              }}
                              id="title-selector"
                              ref={ref}
                              name={name}
                              onBlur={onBlur}
                              value={selectedTitlesList}
                              components={{
                                MultiValueContainer: (props) => (
                                  <components.MultiValueContainer {...props}>
                                    <div className="flex w-full">{props.children}</div>
                                  </components.MultiValueContainer>
                                ),
                                LoadingIndicator: () =>
                                  isbnIsLoading ? <CustomSelectLoader /> : null,
                              }}
                              isLoading={isbnIsLoading}
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  pointerEvents: isLoading ? "none" : "auto",
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  position: `${watch("title")?.length ? "relative" : "absolute"}`,
                                  pointerEvents: isLoading ? "none" : "auto",
                                  left: 6,
                                  marginRight: "10px",
                                  caretColor: isLoading ? "transparent" : "auto",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: "6px",
                                  minWidth: "none",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor:
                                    state.isSelected || state.isFocused
                                      ? "#E6E6E6"
                                      : "",
                                  color: state.isSelected ? "black" : "black",
                                }),
                                valueContainer: (provided) => ({
                                  position: "relative",
                                  maxWidth: "100%",
                                  width: "100%",
                                  paddingLeft: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "32px",
                                  paddingRight: "8px",
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                  minWidth: "50px",
                                  boxSizing: "border-box",
                                  ...(isFirefox && {
                                    scrollbarWidth: "thin",
                                  }),
                                }),
                                control: (provided) => ({
                                  display: "flex",
                                  height: "32px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }),
                                menuList: (provided) => ({
                                  maxHeight: "200px",
                                  overflow: "hidden",
                                  overflowY: "auto",
                                }),
                                clearIndicator: () => ({
                                  marginLeft: "15px",
                                  marginTop: "5px",
                                  color: "gray",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                  position: "absolute",
                                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: isLoading ? -1 : 1050,
                                }),
                              }}
                              noOptionsMessage={() => "Title not found"}
                              className="border border-solid border-neutral-200 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                              onChange={(selectedOptions) => onChange(selectedOptions)}
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              options={reorderedOptions}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex items-end gap-1.5 shrink-0 ml-1">
                    <button
                      type="button"
                      className={`${isLoading ? "bg-[#f87171]" : "bg-[#e31c23] hover:bg-red-700"} text-white flex justify-center items-center px-4 rounded-md cursor-pointer h-[32px] font-poppins font-semibold border border-none min-w-[80px]`}
                      onClick={(e) => {
                        e.preventDefault();
                        downloadSegData({
                          season: selectedSeason ?? [],
                          paperCutOffDate: selectedPaperCutOffDate ?? [],
                          ldc: selectedLdc ?? [],
                          Division: selectedDivision ?? [],
                          Imprint: selectedImprint ?? [],
                          isbns: selectedIsbns ?? [],
                          sortBy: SegReducer.titleSortBy,
                        });
                      }}
                    >
                      Export
                    </button>
                    <button
                      type="button"
                      disabled={meetingReportLoading || isLoading}
                      className={`${meetingReportLoading || isLoading ? "bg-[#f87171]" : "bg-[#e31c23] hover:bg-red-700"} text-white flex justify-center items-center px-4 rounded-md cursor-pointer h-[32px] font-poppins font-semibold border border-none min-w-[120px]`}
                      onClick={(e) => {
                        e.preventDefault();
                        downloadMeetingReportPdf();
                      }}
                    >
                      {meetingReportLoading ? "Generating..." : "Meeting Report"}
                    </button>
                    <button
                      type="button"
                      disabled={buttonDisabled || isLoading}
                      className={`${isLoading || buttonDisabled ? "bg-[#f87171]" : "bg-[#e31c23] hover:bg-red-700"} text-white flex justify-center items-center px-4 rounded-md cursor-pointer h-[32px] font-poppins font-semibold border border-none min-w-[80px]`}
                      onClick={handleFilterClear}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              </form>
            )}
            />
            <div
            ref={reportContainerRef}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "1400px",
              zIndex: -1,
              pointerEvents: "none",
              opacity: 0,
            }}
          >
            {meetingReportSections.flatMap((section, index) => {
              const distributionRows = section.rows.filter((row) => row.rowType === "distribution");
              const pages = chunkRows(distributionRows, 14);
              const footerTotals = getSectionFooterTotals(distributionRows);
              return pages.map((pageRows, pageIndex) => (
                <div
                  key={`${section.isbn}-${index}-p-${pageIndex}`}
                  className="meeting-report-section"
                  style={{
                    width: "1400px",
                    minHeight: "980px",
                    padding: "14px",
                    background: "#ffffff",
                    color: "#111827",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "10px",
                    lineHeight: 1.2,
                    boxSizing: "border-box",
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 700, marginBottom: "6px" }}>
                    SEG Meeting Report - ISBN {section.isbn || "-"} (Page {pageIndex + 1} of {pages.length})
                  </div>
                  {pageIndex === 0 && (
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginBottom: "8px" }}>
                      <div style={{ border: "1px solid #d1d5db", borderRadius: "6px", padding: "6px" }}>
                        <div style={{ fontWeight: 700, marginBottom: "6px" }}>SEG Title</div>
                        <div><strong>Title:</strong> {section.segTitle?.FULL_TITLE || "-"}</div>
                        <div><strong>Author:</strong> {section.segTitle?.AUTHOR_1 || "-"}</div>
                        <div><strong>ISBN:</strong> {section.segTitle?.EAN || section.isbn || "-"}</div>
                        <div><strong>Season:</strong> {section.segTitle?.SEASON || "-"}</div>
                        <div><strong>Pub Date:</strong> {formatDateString(section.segTitle?.PUB_DATE)}</div>
                        <div><strong>Release Date:</strong> {formatDateString(section.segTitle?.RELEASE_DATE)}</div>
                        <div><strong>Paper Cut Off Date:</strong> {formatDateString(section.segTitle?.PAPER_CUT_OFF, "MM/DD/YY")}</div>
                        <div><strong>LDC:</strong> {formatDateString(section.segTitle?.LDC)}</div>
                        <div><strong>Format:</strong> {section.segTitle?.FORMAT || "-"}</div>
                        <div><strong>US Price:</strong> {section.segTitle?.US_PRICE ? formatCurrency(section.segTitle?.US_PRICE) : "-"}</div>
                        <div><strong>Imprint:</strong> {section.segTitle?.TESTIMPRINTFROMHNA || "-"}</div>
                        <div><strong>Division:</strong> {section.segTitle?.GROUP_1 || "-"}</div>
                        <div><strong>Prnt:</strong> {section.segTitle?.PRINT_RUN ?? "-"}</div>
                        <div><strong>Pages:</strong> {section.segTitle?.PAGES ?? "-"}</div>
                        <div><strong>Trim:</strong> {`${section.segTitle?.TRIMLENGTH ?? ""}${section.segTitle?.TRIMLENGTH && section.segTitle?.TRIMWIDTH ? ", " : ""}${section.segTitle?.TRIMWIDTH ?? ""}` || "-"}</div>
                        <div><strong>Title Notes:</strong> {section.segTitleNotes || "-"}</div>
                        <div>
                          <strong>Ttl Est:</strong>{" "}
                          {decimalToString(
                            section.rows
                              .filter((row) => row.rowType === "distribution")
                              .reduce((sum, row) => sum + normalizeNumeric(row.laydownEstimate), 0)
                          )}
                        </div>
                      </div>
                      <div style={{ border: "1px solid #d1d5db", borderRadius: "6px", padding: "6px" }}>
                        <div style={{ fontWeight: 700, marginBottom: "6px" }}>Comparative Title</div>
                        {section.comparableTitle ? (
                          <>
                            <div><strong>Title:</strong> {section.comparableTitle?.FULL_TITLE || "-"}</div>
                            <div><strong>Author:</strong> {section.comparableTitle?.AUTHOR_1 || "-"}</div>
                            <div><strong>ISBN:</strong> {section.comparableTitle?.EAN || "-"}</div>
                            <div><strong>Season:</strong> {section.comparableTitle?.SEASON || "-"}</div>
                            <div><strong>Pub Date:</strong> {formatDateString(section.comparableTitle?.PUB_DATE)}</div>
                            <div><strong>Release Date:</strong> {formatDateString(section.comparableTitle?.RELEASE_DATE)}</div>
                            <div><strong>Format:</strong> {section.comparableTitle?.FORMAT || "-"}</div>
                            <div><strong>US Price:</strong> {section.comparableTitle?.US_PRICE ? formatCurrency(section.comparableTitle?.US_PRICE) : "-"}</div>
                            <div><strong>LTD:</strong> {section.comparableLtd ?? "-"}</div>
                            <div><strong>eBook Sales:</strong> {section.comparableEbookSales ?? "-"}</div>
                            <div><strong>Imprint:</strong> {section.comparableTitle?.TESTIMPRINTFROMHNA || "-"}</div>
                            <div><strong>Division:</strong> {section.comparableTitle?.GROUP_1 || "-"}</div>
                            <div><strong>BkSn Pos:</strong> {section.comparableBksnPos ?? "-"}</div>
                          </>
                        ) : (
                          <div>No comparable title mapping available.</div>
                        )}
                      </div>
                    </div>
                  )}
                  <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <thead>
                      <tr>
                        {[
                          "Distribution Channel",
                          "INITIAL ORDER",
                          "Sales Notes",
                          "Laydown Goal",
                          "Laydown Estimate",
                          "6-month Estimate (incl Laydown)",
                          "COMP TITLE INITIAL ORDER",
                          "COMP TITLE GROSS SALES",
                          "COMP TITLE NET SALES",
                          "COMP TITLE % RETURNS",
                          "COMP TITLE 4wk POS",
                          "COMP TITLE 8wk POS",
                          "COMP TITLE LTD POS",
                        ].map((heading) => (
                          <th
                            key={`${heading}-${pageIndex}`}
                            style={{
                              border: "1px solid #d1d5db",
                              padding: "3px",
                              fontSize: "8px",
                              fontWeight: 700,
                              textAlign: "left",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              lineHeight: 1.1,
                            }}
                          >
                            {heading}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {pageIndex === 0 && (
                        <tr style={{ background: "#e5e7eb", fontWeight: 700 }}>
                          {[
                            "Total",
                            decimalToString(footerTotals.initialOrder),
                            "",
                            decimalToString(footerTotals.laydownGoal),
                            decimalToString(footerTotals.laydownEstimate),
                            decimalToString(footerTotals.sixMonthEstimate),
                            decimalToString(footerTotals.compInit),
                            decimalToString(footerTotals.compGross),
                            decimalToString(footerTotals.compNet),
                            "",
                            "",
                            "",
                            decimalToString(footerTotals.compLtdPos),
                          ].map((cell, idx) => (
                            <td
                              key={`${section.isbn}-top-total-${idx}`}
                              style={{
                                border: "1px solid #9ca3af",
                                padding: "3px",
                                fontSize: "8px",
                                textAlign: idx === 0 ? "left" : "center",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {cell}
                            </td>
                          ))}
                        </tr>
                      )}
                      {pageRows.map((row, rowIndex) => {
                        const rowBg =
                          row.rowType === "distribution"
                            ? "#fce7f3"
                            : row.rowType === "organization"
                              ? "#f3f4f6"
                              : "#ffffff";
                        return (
                          <tr key={`${section.isbn}-row-${pageIndex}-${rowIndex}`} style={{ background: rowBg }}>
                            {[
                              row.distributionChannel,
                              row.initialOrder,
                              row.salesNotes,
                              row.laydownGoal,
                              row.laydownEstimate,
                              row.sixMonthEstimate,
                              row.compInit,
                              row.compGross,
                              row.compNet,
                              row.compReturns,
                              row.comp4wkPos,
                              row.comp8wkPos,
                              row.compLtdPos,
                            ].map((cell, cellIndex) => (
                              <td
                                key={`${section.isbn}-row-${pageIndex}-${rowIndex}-cell-${cellIndex}`}
                                style={{
                                  border: "1px solid #d1d5db",
                                  padding: "3px",
                                  fontSize: "8px",
                                  textAlign: "left",
                                  whiteSpace: cellIndex === 0 ? "pre-line" : "normal",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                }}
                              >
                                {cellIndex === 0
                                  ? cell || (row.rowType === "distribution" ? "Not Defined" : "")
                                  : cell || "-"}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ));
            })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SegMainTable;


